import { flow } from 'lodash';

import { applyParameterGroupParameter, initialTransforms } from '../utils';

const pieWorkflow = flow(initialTransforms, applyParameterGroupParameter);

export { pieWorkflow };
